import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaEnvelope, FaCheckCircle } from 'react-icons/fa';
import { Logo } from '../../components/images';

const RegistrationSuccess = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    // Get email from navigation state
    const userEmail = location.state?.email || 'your email';

    const handleContinue = () => {
        navigate("/", { state: { formSignup: true } });
    };

    return (
        <div className='bg-gradient-to-br from-orange-200 to-orange-500 min-h-screen w-full p-4 sm:p-6 lg:p-10'>
            {/* Header - Responsive */}
            <div>
                <Link to="/main-signup">
                    <div className='flex flex-row items-center mb-6 sm:mb-8'>
                        <img src={Logo} className='w-8 h-8 sm:w-10 sm:h-10' alt="Logo"/>
                        <p className='text-lg sm:text-xl lg:text-2xl ml-2 font-medium text-gray-800'>
                            Oodles Internships
                        </p>
                    </div>
                </Link>
            </div>

            <div className="flex justify-center items-center">
                <div className='flex flex-col gap-6 p-8 md:p-12 bg-white shadow-2xl max-w-xl w-full rounded-xl'>
                    {/* Success Icon */}
                    <div className="flex justify-center">
                        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                            <FaCheckCircle className="text-green-500 text-2xl" />
                        </div>
                    </div>

                    <h2 className="text-2xl font-bold text-gray-800 text-center">
                        Registration Successful!
                    </h2>
                    
                    <div className="space-y-4 text-left">
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                            <div className="flex items-center mb-3">
                                <FaEnvelope className="text-blue-500 mr-2" />
                                <h3 className="font-semibold text-blue-900">Verify Your Email</h3>
                            </div>
                            <p className="text-blue-800 mb-3">
                                We've sent a verification email to:
                            </p>
                            <p className="font-medium text-blue-900 bg-white px-3 py-2 rounded border">
                                {userEmail}
                            </p>
                        </div>

                        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                            <h4 className="font-semibold text-yellow-900 mb-2">Next Steps:</h4>
                            <ul className="text-yellow-800 space-y-1 text-sm">
                                <li>• Check your email inbox (and spam folder)</li>
                                <li>• Click the verification link in the email</li>
                                <li>• Return to complete your profile setup</li>
                            </ul>
                        </div>

                        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                            <p className="text-gray-700 text-sm">
                                <strong>Note:</strong> You can continue setting up your profile now. 
                                Some features may be limited until you verify your email address.
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-3 pt-4">
                        <button
                            onClick={handleContinue}
                            className="bg-orange-500 text-white px-6 py-3 rounded-lg font-medium hover:bg-orange-600 transition-colors flex-1"
                        >
                            Continue to Profile Setup
                        </button>
                        <Link 
                            to="/login"
                            className="bg-gray-500 text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-600 transition-colors text-center flex-1"
                        >
                            Sign In Later
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegistrationSuccess;